// extracted by mini-css-extract-plugin
module.exports = {"container":"footerMenu_container__2eMMu","footerMenu":"footerMenu_footerMenu__1ywdw","menuItem":"footerMenu_menuItem__YjAXo"};